import { Tolgee, LanguageDetector, LanguageStorage } from '@tolgee/react';
import { FormatIcu } from '@tolgee/format-icu';
import { BraceFormat } from 'services/i18n/plugins/BraceFormat';
import dayjs from 'lib/dayjs';
import { setNumberFormatLocale } from 'utils/numberFormat';
import { PluralFormat } from './plugins/PluralFormat';
import { AppNameFormat } from './plugins/AppNameFormat';
import { loadResources, reportMissingKey } from './utils';

export const tolgee = Tolgee()
  .use(LanguageStorage())
  .use(LanguageDetector())
  .use(BraceFormat())
  .use(AppNameFormat())
  .use(PluralFormat())
  .use(FormatIcu())
  .init({
    defaultLanguage: 'en-US',
    availableLanguages: ['zh-CN', 'en-US', 'id', 'th', 'tl', 'vi', 'pt', 'es'],
    fallbackLanguage: 'en-US',
    apiUrl: import.meta.env.VITE_TOLGEE_API_URL,
    apiKey: import.meta.env.VITE_TOLGEE_API_KEY,
    staticData: {
      'zh-CN': () =>
        loadResources([
          import('services/i18n/resources/zh-CN.json').then((m) => m.default),
          import('services/i18n/resources-new/zh-Hans-CN.json').then((m) => m.default),
        ]),
      'en-US': () =>
        loadResources([
          import('services/i18n/resources/en-US.json').then((m) => m.default),
          import('services/i18n/resources-new/en-US.json').then((m) => m.default),
        ]),
      id: () =>
        loadResources([
          import('services/i18n/resources/id.json').then((m) => m.default),
          import('services/i18n/resources-new/id-ID.json').then((m) => m.default),
        ]),
      th: () =>
        loadResources([
          import('services/i18n/resources/th.json').then((m) => m.default),
          import('services/i18n/resources-new/th-TH.json').then((m) => m.default),
        ]),
      tl: () =>
        loadResources([
          import('services/i18n/resources/tl.json').then((m) => m.default),
          import('services/i18n/resources-new/fil-PH.json').then((m) => m.default),
        ]),
      vi: () =>
        loadResources([
          import('services/i18n/resources/vi.json').then((m) => m.default),
          import('services/i18n/resources-new/vi-VN.json').then((m) => m.default),
        ]),
      pt: () =>
        loadResources([
          import('services/i18n/resources/pt.json').then((m) => m.default),
          import('services/i18n/resources-new/pt-BR.json').then((m) => m.default),
        ]),
      es: () =>
        loadResources([
          import('services/i18n/resources/es.json').then((m) => m.default),
          import('services/i18n/resources-new/es-MX.json').then((m) => m.default),
        ]),
    },
    onTranslationMissing: (data) => {
      const { key } = data;
      reportMissingKey(key);
      return key;
    },
  });

tolgee.on('language', ({ value }) => {
  const m: Record<string, string> = {
    'zh-CN': 'zh-cn',
    'en-US': 'en',
    id: 'id',
    th: 'th',
    tl: 'tl-ph',
    vi: 'vi',
    pt: 'pt',
    es: 'es',
  };

  dayjs.locale(m[value]);
  setNumberFormatLocale(value as General.SystemLanguage);
});
